<template>
    <div class="goods-import">
        <bread-crumb :list="[{
            text: '商品列表',
            url: '/main/goodsLibrary/nav/goodsList'
        }, {
            text: '商品导入'
        }]"/>
        <!-- 表格导入 -->
        <div class="fx-v-center fx-h-between">
            <span class="href fs-14" @click="isShowImportRecord = true">导入记录</span>
        </div>
        <router-view class="router-view" />
        <!-- components -->
        <import-record :visible.sync="isShowImportRecord" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed } from '@vue/composition-api'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import Tabs from '@/components/tabs/tabs.vue'
import ImportRecord from './components/import_record.vue'

export default createComponent({
    setup: (props, ctx) => {
        const isImporting = ref(false)
        const isShowImportRecord = ref(false)

        return {
            isImporting,
            isShowImportRecord
        }
    },

    components: {
        BreadCrumb,
        ImportRecord
    }
})
</script>

<style lang="scss" scoped>
.router-view {
    margin-top: 12px;
}
</style>
